import axios from "axios";
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState
} from "react";
import toast from "react-hot-toast";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import { baseServiceUrl, urls } from "../../environment";

import useUserStore from "../../stores/useUserStores";
type OfflineResultUploadModalProps = {};
const OfflineResultUploadModal: FC<
  OfflineResultUploadModalProps
> = ({}): JSX.Element => {
  const {
    token,
    setLoading,
    setIsResultUploadedUploadedForOfflineCentre,
    loading,
    setOfflineExamLineInformation,
    offlineExamInformation,
    isResultIsUploaded,
    isResultUploadedForOfflineCentre,
    setTests,
    tests,
  } = useUserStore();
  const uploadResult = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${baseServiceUrl}${urls.uploadResultForOffline}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      const responseExam = await axios.get(
        baseServiceUrl + urls.getAllExamUrl,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      if (responseExam.data) {
        setTests(response.data);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || "Error encounter. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-[rgba(0,0,0,0.5)] z-[85] fixed top-0 left-0">
      <div className="w-full h-full   ">
        <div className="flex justify-center w-full h-full items-center">
          <div className="lg:w-[40vw]  mx-auto  shadow-lg max-h-[200px] bg-white z-[99] rounded-md">
            <div className="bg-[#fef9c3]  p-2 rounded-tl-md rounded-tr-md flex gap-x-4 items-center justify-start ">
              <FiAlertCircle size={20} className="text-yellow-500 " />
              <p className="text-gray-500">
                Upload Your Centre Exam Result to Centralized Server
              </p>
            </div>
            <div className="bg-white flex py-10 items-center justify-center">
              <button
                onClick={() => uploadResult()}
                className=" px-4 text-gray-500 group rounded-md py-1 transition-all duration-500  hover:bg-[#2563EB] flex  items-center justify-center border border-[#2563EB] gap-x-3 group"
              >
                <FaCloudUploadAlt
                  className="text-[#2563EB] group-hover:text-white transition-all duration-500 ease-linear "
                  size={20}
                />
                <p className="text-base font-semibold group-hover:text-white transition-all ease-out duration-500">
                  Upload Result
                </p>
                {loading ? (
                  <div className="animate-spin h-5 w-5 mr-3 border border-gray-500 border-t-white rounded-full transition-all linear duration-500 " />
                ) : (
                  <></>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineResultUploadModal;
